import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import NRouter, { Link } from '../../router';
import messages from '../messages';

const NUM_INDEXABLE_PAGES = 10;
const MAX_PAGES = 100;

const { previousPage, nextPage, page } = messages;

class Paginate extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleNextPage = this.handleNextPage.bind(this);
    this.handlePrevPage = this.handlePrevPage.bind(this);
  }

  handleNextPage() {
    const { currentPage, onPageChange } = this.props;
    onPageChange(currentPage + 1);
  }

  handlePrevPage() {
    const { currentPage, onPageChange } = this.props;
    onPageChange(currentPage - 1);
  }

  renderPrevious() {
    const { currentPage, prevPageParams } = this.props;
    if (currentPage > 1) {
      /**
       * NOTE: We need to compute the target url and, we can't let the 'next-routes'
       * compute it automatically using the form <Link route={params.routeName} params={params}>
       * because when user access via DSA URL (those with 'tg' query param) we need
       * to hold the 'tg' param between pages.
       */
      const urls = NRouter.findAndGetUrls(prevPageParams.routeName, prevPageParams).urls;

      if (currentPage <= NUM_INDEXABLE_PAGES + 1) {
        return (
          <Link href={urls.href} as={urls.as}>
            <a onClick={this.handlePrevPage}>
              &lsaquo; <FormattedMessage {...previousPage} />
            </a>
          </Link>
        );
      }

      return (
        <Link href={urls.href} as={urls.as}>
          <a rel="nofollow" onClick={this.handlePrevPage}>
            &lsaquo; <FormattedMessage {...previousPage} />
          </a>
        </Link>
      );
    }

    return null;
  }

  renderNext() {
    const { currentPage, nextPageParams, showNext } = this.props;

    if (showNext && currentPage < MAX_PAGES) {
      /**
       * NOTE: We need to compute the target url and, we can't let the 'next-routes'
       * compute it automatically using the form <Link route={params.routeName} params={params}>
       * because when user access via DSA URL (those with 'tg' query param) we need
       * to hold the 'tg' param between pages.
       */
      const urls = NRouter.findAndGetUrls(nextPageParams.routeName, nextPageParams).urls;

      if (currentPage < NUM_INDEXABLE_PAGES) {
        return (
          <Link href={urls.href} as={urls.as}>
            <a onClick={this.handleNextPage}>
              <FormattedMessage {...nextPage} /> &rsaquo;
            </a>
          </Link>
        );
      }

      return (
        <Link href={urls.href} as={urls.as}>
          <a rel="nofollow" onClick={this.handleNextPage}>
            <FormattedMessage {...nextPage} /> &rsaquo;
          </a>
        </Link>
      );
    }

    return null;
  }

  render() {
    const { currentPage, showNext } = this.props;

    if (currentPage === 1 && !showNext) {
      return null;
    }

    return (
      <div className="paginate" data-test="pager">
        <span className="prev" data-test="p-prev">
          {this.renderPrevious()}
        </span>
        <strong className="current">
          <FormattedMessage {...page} /> {currentPage}
        </strong>
        <span className="next" data-test="p-next">
          {this.renderNext()}
        </span>
        <style jsx>
          {`
            .paginate {
              border-bottom: 1px solid rgba(0, 0, 0, 0.1);
              border-top: 1px solid rgba(0, 0, 0, 0.1);
              box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.03);
              font-size: 0.875em; /* 14/16 */
              padding: 18px 15px 19px;
              margin-bottom: 2px;
              text-align: center;
            }
            .prev {
              text-align: left;
            }
            .next {
              text-align: right;
            }
            :global(.rtl) .prev {
              text-align: right;
            }
            :global(.rtl) .next {
              text-align: left;
            }
            .current,
            .prev,
            .next {
              display: inline-block;
              width: 33.3333%;
            }
          `}
        </style>
      </div>
    );
  }
}

Paginate.defaultProps = {
  currentPage: 1,
};

Paginate.propTypes = {
  currentPage: PropTypes.number,
  showNext: PropTypes.bool.isRequired,
  nextPageParams: PropTypes.object.isRequired,
  prevPageParams: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Paginate;



// WEBPACK FOOTER //
// ./app/Serp/components/Paginate.js